import React from 'react';

interface FormTooltipProps {
  content: string;
  children?: React.ReactNode;
}

export const FormTooltip: React.FC<FormTooltipProps> = ({ content, children }) => {
  return (
    <span className="app-form-tooltip">
      <span className="app-form-tooltip-icon">{children || '?'}</span>
      <span className="app-form-tooltip-content">{content}</span>
    </span>
  );
};